export const typeMap: Record<string, string[]> = {
    pending: ['Pending', 'Pending'],
    verified: ['Verified', 'Verified'],
    completed: ['Completed', 'Completed'],
    reviewRequired: ['Review', 'Review Required'],
    purged: ['Purged', 'Purged'],
    processingVerification: ['Processing', 'Processing Verification'],
    sendToRework: ['Sent-to-Rework', 'Sent to Rework'],
    escalated: ['Escalated', 'Escalated'],
    categorisationFailed: ['Fix', 'Categorisation Failed'],
    categorisationProcessing: ['MoveCM9', 'Categorisation Processing'],
    categorisationCompleted: [
        'Categorisation-Completed',
        'Categorisation Completed',
    ],
    validationFailed: ['Validation-Failed', 'Validation Failed'],
    duplicatedPacket: ['Duplication-Packet', 'Duplication Packet'],
    duplicationFound: ['Duplication-Found', 'Duplication Found'],
    documentMissing: ['Document-Missing', 'Document Missing'],
    emptyPacket: ['Empty-Packet', 'Empty Packet'],
    reworked: ['Reworked', 'Reworked'],
    reworkNotExpected: ['No-Reworked', 'No Reworked'],
    duplicateWithAllNewDocs: ['New-Duplicate', 'Duplicate - New docs'],
    partiallyDuplicate: ['Partial-Duplicate', 'Partial Duplication'],
    fullyDuplicate: ['Full-Duplicate', 'Fully Duplication'],
    attachedWithOriginalPacket: ['Origin-Attachment', 'Original Attachment'],
    notExpected: ['Not-Expected', 'Not Expected'],
    categorising: ['Categorising', 'Categorising'],
    Categorising: ['Categorising', 'Categorising'],
    noDocumentsFound: ['No-Documents-Found', 'No Document Found'],
    verifying: ['Verifying', 'Processing QA'],
    sentForRework: ['Sent-for-Rework', 'Sent for Rework'],
    uploading: ['Uploading', 'Uploading'],
    scanning: ['Scanning', 'Scanning'],
    scanningCompleted: ['Scanning-Completed', 'Scanning Completed'],
    groupingCompleted: ['Grouping-Completed', 'Grouping Completed'],
    groupingFailed: ['Grouping-Failed', 'Grouping Failed'],
    grouping: ['Grouping', 'Grouping'],
    generatingReport: ['Generating-Report', 'Generating Report'],
    virusFound: ['Virus-Found', 'Virus Found'],
    encrypted: ['Encrypted', 'Encrypted'],
    corrupted: ['Corrupted', 'Corrupted'],
};
